<template>
  <div>

    <div class="breadcrumb">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/student/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <span>Applications</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div class="table" v-if="filteredApplications">
      <div class="trow">
        <div class="thead app-id" @click="() => sortApplications('seq_id')">Application ID</div>
        <div class="thead app-date" @click="() => sortApplications('display_date')">Applied Date</div>
        <div class="thead school-name" @click="() => sortApplications('display_school')">School Name</div>
        <div class="thead program-name" @click="() => sortApplications('name')">Program Name</div>
        <div class="thead intake" @click="() => sortApplications('intake')">Intake</div>
        <div class="thead status" @click="() => sortApplications('status')">Status</div>
      </div>
      <div class="trow">
        <div class="tdata app-id">
          <input type="text" placeholder="Search Application ID" v-model="searchID" @keyup="(ev) => searchApplications('searchID', ev.target.value)" />
        </div>
        <div class="tdata app-date">
          <input type="text" placeholder="Search Applied Date" v-model="searchDate" @keyup="(ev) => searchApplications('searchDate', ev.target.value)" />
        </div>
        <div class="tdata school-name">
          <input type="text" placeholder="Search School Name" v-model="searchSchool" @keyup="(ev) => searchApplications('searchSchool', ev.target.value)" />
        </div>
        <div class="tdata program-name">
          <input type="text" placeholder="Search Program Name" v-model="searchProgram" @keyup="(ev) => searchApplications('searchProgram', ev.target.value)" />
        </div>
        <div class="tdata intake">
          <input type="text" placeholder="Search Intake" v-model="searchSchool" @keyup="(ev) => searchApplications('searchIntake', ev.target.value)" />
        </div>
        <div class="tdata status">
          <input type="text" placeholder="Search Status" v-model="searchStatus" @keyup="(ev) => searchApplications('searchStatus', ev.target.value)" />
        </div>
      </div>
      <div class="trow" v-for="application in filteredApplications" :key="application.id">
        <div class="tdata app-id">{{application.seq_id}}</div>
        <div class="tdata app-date">{{application.display_date}}</div>
        <div class="tdata school-name">{{application.display_school}}</div>
        <div class="tdata program-name">{{application.name}}</div>
        <div class="tdata intake">{{application.intake}}</div>
        <div class="tdata status">{{application.status}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'StudentApplications',
  data () {
    return {
      searchID: '',
      searchDate: '',
      searchSchool: '',
      searchProgram: '',
      searchStatus: '',
      searchIntake: '',
      filteredApplications: null,
      sorted: {}
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'userApplications'
    ])
  },
  watch: {
    user: {
      handler (val) {
        if (val) {
          if (!this.applications) {
            this.$store.dispatch('getUserApplications', val.ref)
          }
        }
      }
    },
    userApplications: {
      handler (val) {
        if (!val && this.user) {
          this.$store.dispatch('getUserApplications', this.user.ref)
        } else if (val) {
          this.filteredApplications = val.map(x => {
            x.display_date = `${('0' + (x.created_at.getMonth() + 1)).slice(-2)}-${('0' + (x.created_at.getDate())).slice(-2)}-${x.created_at.getFullYear()}`
            x.display_school = `${x.school_name}, ${x.school.campus}`
            return x
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    searchApplications (key, val) {
      this[key] = val

      if (!this.searchID && !this.searchDate && !this.searchSchool && !this.searchProgram && !this.searchStatus && !this.searchIntake) {
        this.filteredApplications = [...this.userApplications]
      } else {
        this.filteredApplications = this.userApplications.filter(x => {
          if (this.searchID && x.seq_id.toLowerCase().indexOf(this.searchID.toLowerCase()) == -1) {
            return false
          }
          if (this.searchDate && x.display_date.toLowerCase().indexOf(this.searchDate.toLowerCase()) == -1) {
            return false
          }
          if (this.searchSchool && x.display_school.toLowerCase().indexOf(this.searchSchool.toLowerCase()) == -1) {
             return false
          }
          if (this.searchProgram && x.name.toLowerCase().indexOf(this.searchProgram.toLowerCase()) == -1) {
            return false
          }
          if (this.searchIntake && x.intake.toLowerCase().indexOf(this.searchIntake.toLowerCase()) == -1) {
            return false
          }
          if (this.searchStatus && x.status.toLowerCase().indexOf(this.searchStatus.toLowerCase()) == -1) {
            return false
          }
          return true
        })
      }
    },
    sortApplications (col) {
      let applications = [...this.filteredApplications]
      let sortedAscending = [...this.filteredApplications]
      
      sortedAscending.sort((x, y) => x[col] > y[col] ? 1 : y[col] > x[col] ? -1 : 0)
      if (this.sorted[col] === undefined) {
        this.sorted[col] = !sortedAscending.every((item, index) => item[col] === applications[index][col])
      } else {
        this.sorted[col] = !this.sorted[col]
      }

      if (this.sorted[col]) {
        this.filteredApplications = applications.sort((x, y) => x[col] > y[col] ? 1 : y[col] > x[col] ? -1 : 0)
      } else {
        this.filteredApplications = applications.sort((x, y) => x[col] > y[col] ? -1 : y[col] > x[col] ? 1 : 0)
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  padding: 16px;
}
.applications-wrap {
  padding: 16px;
}
.table {
  width: 98%;
  margin: 18px auto;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 15px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 13px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
}
.table .tdata input {
  width: 100%;
  margin: auto;
  padding: 4px 7px;
  height: 28px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0,0,0,.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all .3s;
  transition: all .3s;
}
.trow .app-id {
  width: 11%;
  text-align: center;
}
.trow .app-date {
  width: 10%;
  text-align: center;
}
.trow .school-name {
  width: 26%;
}
.trow .program-name {
  width: 33%;
}
.trow .intake {
  width: 10%;
}
.trow .status {
  width: 10%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Student/StudentApplications.vue